import React from 'react';
import {
  OPERATIONAL_ASSETS_DOCUMENT_HR_TYPES_VALUES,
  OPERATIONAL_ASSETS_DOCUMENT_SECTIONS_VALUES,
} from 'domain/gpo/processAssets/constants';
import { ProcessAssetsType } from 'domain/gpo/processAssets/types';
import { useShowContext } from 'framework/show';
import { Typography } from '@mui/material';

const CombineSectionFileTypeField = (props: any) => {
  const { data } = useShowContext<ProcessAssetsType>();
  const {
    metadata: { section, fileType },
  } = data.getData();

  const sectionText =
    OPERATIONAL_ASSETS_DOCUMENT_SECTIONS_VALUES[section as keyof typeof OPERATIONAL_ASSETS_DOCUMENT_SECTIONS_VALUES];
  const fileTypeText =
    OPERATIONAL_ASSETS_DOCUMENT_HR_TYPES_VALUES[fileType as keyof typeof OPERATIONAL_ASSETS_DOCUMENT_HR_TYPES_VALUES];

  return (
    <Typography display="flex" component="span">
      {sectionText} / {fileTypeText}
    </Typography>
  );
};

export default CombineSectionFileTypeField;
